

















import Vue from 'vue'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
import StripeCustomer from '@/types/StripeCustomer.interface'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import User from '@/types/User.interface'
export default Vue.extend({
    mixins: [subscriptionMixin],
    components: {
        StripeElementCard
    },
    props: {
        //  Data is only needed when we go through subscription-mixin.js (tbh I'm unsure if data is used anymore but that's beyond the scope and takes more testing so we just pass it)
        data: {
            type: Object, 
            required: false,
            default: null
        },  
        //  This is used mainly for styling of the component to know how we render the stripe payment info 
        isRegistrationPage: {
            type: Boolean, 
            default: false
        },
        //  This is used so we don't emit the submit event since the subscription-mixin doesn't use this as a direct component but isntead as a dialog
        isSubscriptionMixin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //  Temp address storage which we pass to Stripe
            address: {},

            //  Stripe private key needed to create a Stripe instance
            privateKey: process.env.VUE_APP_STRIPE_KEY,
            googleMapsPrivateKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
            spinner: false,

            //  Essentially stripe address object which we use to access certain functions provided by Stripe
            stripeAddressElement: null
        }
    },
    mounted() {
        //@ts-ignore init stripe object which we can create elements from
        const stripe = Stripe(this.privateKey)

        //  Create and configure our address element, to add more configuration add additonal parameters to the json obj
        //  View Stripe docs here to see configuration options https://stripe.com/docs/js/elements_object/create_address_element#address_element_create-options
        this.stripeAddressElement = stripe.elements('address').create('address', { 
            mode: 'billing' ,
            autocomplete: {
                mode: 'google_maps_api',
                apiKey: this.googleMapsPrivateKey
            },
            defaultValues: {
                name: this.user.fullname
            }
        })

        //  Mount our address element to be rendered to the user, this will render where the div with id='address-element' is
        this.stripeAddressElement.mount('#address-element')
    },
    computed: {
        //  Needed to auto fill name for Stripe address element
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        formatAddress(address): void {
            //  Since this address element is newer than our Vue stripe card component we have to manually map the address values to the token values 
            this.address.address_line1 = address.line1 || ''
            this.address.address_line2 = address.line2 || ''
            this.address.address_city = address.city || ''
            this.address.address_country = address.country || ''
            this.address.address_state = address.state || ''
            this.address.address_zip = address.postal_code || ''
        }, 
        async generateToken(): Promise<void> {
            //  Start spinning
            this.spinner = true
            
            //  We grab the complete boolean that stripe returns as well as value which contains the name of the customer as well as the address of the customer 
            const {complete, value} = await this.stripeAddressElement.getValue()
             
            //  If the user left any required field blank, we stop the spinner and the Stripe element will automatically highlight what is missing or wrong 
            if (!complete) {
                this.spinner = false 
                return 
            }
            
            //  Pass our address so it can be formatted and saved to this.address 
            this.formatAddress(value.address)
            
            //  Tell our card to generate a token 
            this.$refs.stripeCardElement.submit()
        },
        async submit(token: StripeCustomer): Promise<void> {
            //  Update stripe customer using fxn in subscription-mixin.js, we pass true as our last field so we can close the dialog, while registration doesn't use a dialog this has no
            //  negative effect on it 
            const response = await this.cardAddedSuccess(token.id, this.data, true)

            // If invalid response, don't move to next step
            if (!response) {
                this.spinner = false
                return
            }
            
            //  If we aren't coming from the subscription-mixin.js then we emit a submit event as RegisterPayment.vue has unique logic 
            //  of what to do next when the card is successfully added 
            if (!this.isSubscriptionMixin)  this.$emit('submit')
        }
    }
})
